import script from "./ExtraProdiInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtraProdiInput.vue?vue&type=script&setup=true&lang=js"

import "./ExtraProdiInput.vue?vue&type=style&index=0&id=d8ae5d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ae5d80"]])

export default __exports__